import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';
import { ArrowLeft, Compass, Mail } from './Icons';
import { CONTACT_EMAIL } from '../data/apps';

export default function NotFound() {
    useEffect(() => {
        document.title = 'Page not found | App Support';
    }, []);

    return (
        <Layout>
            <div className="notfound">
                <span className="pill pill-neutral">
                    <Compass />
                    Off the map
                </span>
                <p className="code grad-text">404</p>
                <h1>We couldn’t find that page</h1>
                <p>
                    The link may be out of date. Head back to the app list, or email us and we’ll send
                    you the right one.
                </p>
                <div className="hero-actions">
                    <Link className="btn btn-primary" to="/">
                        <ArrowLeft />
                        All apps
                    </Link>
                    <a className="btn" href={`mailto:${CONTACT_EMAIL}`}>
                        <Mail />
                        Email support
                    </a>
                </div>
            </div>
        </Layout>
    );
}
